import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const Route = {
  id: PropTypes.number,
  name: PropTypes.string,
  lengthInKilometers: PropTypes.number,
  geometry: MapGeometryShape,
  visible: PropTypes.bool,
};

export const RouteShape = PropTypes.shape(Route);
export const RouteExact = PropTypes.exact(Route);
